import type { ReactNode } from "react"

// Wrapper component
interface DiscoverResultsProps {
  children: ReactNode
}

export function DiscoverResults({ children }: DiscoverResultsProps) {
  return (
    <div className="h-table h-table--full mb-0 mt-0 companies-table">
      {children}
    </div>
  )
}
